export default __webpack_public_path__ + "images/fe3a83082eb2f386f991ca3b6d2d2213-fashion_small.webp";